module.exports = __webpack_public_path__ + "img/social-1.24382f7a.jpg";